import { filter, get } from 'lodash';
import { useCurrentUser } from '@lib/hooks';

const createSingleMessageFilter = <T>(message: T, isToFilterMessagesByMe: boolean) => (
  testCallback: (arg: string) => boolean,
) => {
  if (isToFilterMessagesByMe) {
    const isOutboundMessage = get(message, 'type', '') === 'outbound';
    const createdById = get(message, 'oid_createdBy', '');
    const messageRecipientId = get(message, 'oid_recipient', '');
    if (isOutboundMessage) {
      return testCallback(createdById);
    }
    return testCallback(messageRecipientId);
  }

  const facilityId = get(message, 'oid_facility');
  return testCallback(facilityId);
};

export function useFilterMessagesBySenderAndReceiver<T>(
  messages: T[],
  isToFilterMessagesByMe: boolean,
  allSelectedFacilities: string[],
  shouldFilterByNotIn: boolean = false,
): T[] {
  const currentUser = useCurrentUser();
  const currentUserId = currentUser?.id ?? '';
  const canFilterByFacility = allSelectedFacilities?.length > 0;

  if (messages?.length === 0 || (!isToFilterMessagesByMe && !canFilterByFacility)) {
    return messages;
  }

  return filter(messages, (item) => {
    const singleMessageFilter = createSingleMessageFilter(item, isToFilterMessagesByMe);
    if (isToFilterMessagesByMe) {
      const isSameUser = (userId: string | null) => userId === currentUserId;

      return shouldFilterByNotIn ? !singleMessageFilter(isSameUser) : singleMessageFilter(isSameUser);
    }

    const facilitiesSingleMessageFilter = allSelectedFacilities.includes.bind(allSelectedFacilities);

    return shouldFilterByNotIn
      ? !singleMessageFilter(facilitiesSingleMessageFilter)
      : singleMessageFilter(facilitiesSingleMessageFilter);
  });
}
